import styled from 'styled-components';

export const ConstructionDataContainerBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1rem;
`;

export const ConstructionDataItemContainer = styled.div`
  min-width: 12.5rem;

  & > .description {
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.grayDark4};
  }
`;
